import { render, staticRenderFns } from "./modelDeatail.vue?vue&type=template&id=1e563208&scoped=true"
import script from "./modelDeatail.vue?vue&type=script&lang=js"
export * from "./modelDeatail.vue?vue&type=script&lang=js"
import style0 from "./modelDeatail.vue?vue&type=style&index=0&id=1e563208&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e563208",
  null
  
)

export default component.exports